import React from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import logo from '../assets/email-logo_white.png'
import mail from '../assets/mail.png'
import address from '../assets/address.png'

export class Footer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
    }
  }
  
  render() {
    return (
      <Row className='footer-row'>
        <Col sm={12} md={12} lg={4} className='footer-el'>
          <Row>
            <a href='https://meetglimpse.com/'>
              <img src={logo} className='footer-logo' alt='glimpse' />
            </a>
          </Row>
          <Row>
            <img src={mail} style={{width: 23 * 0.75, height: 16 * 0.75, marginRight: 16, marginTop: 3}} />
            <a href='mailto:hello@meetglimpse.com'>hello@meetglimpse.com</a>
          </Row>
          <Row>
            <img src={address} style={{width: 19 * 0.75, height: 25 * 0.75, marginRight: 19, marginTop: -1}} />
            <span>215 Park Ave, New York, NY </span>
          </Row>
        </Col>
        <Col sm={12} md className='footer-el'>
          <Row>
            <p>Products</p>
          </Row>
          <Row>
            <a href='https://meetglimpse.com#pricing'>
              Reports
            </a>
          </Row>
          <Row>
            <a href='https://meetglimpse.com#enterprise'>
              Custom reports
            </a>
          </Row>
        </Col>
        <Col sm={12} md className='footer-el'>
          <Row>
            <p>Company</p>
          </Row>
          <Row>
            <a href='mailto:hello@meetglimpse.com'>
              Contact
            </a>
          </Row>
          <Row>
            <a href='mailto:jobs@meetglimpse.com'>
              Careers
            </a>
          </Row>
        </Col>
        <Col sm={12} md className='footer-el'>
          <Row>
            <p>Legal</p>
          </Row>
          <Row>
            <a href='https://meetglimpse.com/privacy.html'>
              Privacy policy
            </a>
          </Row>
          <Row>
            <a href='https://meetglimpse.com/terms.html'>
              Terms of service
            </a>
          </Row>
        </Col>
      </Row>
    )
  }
}
